import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "loading inset-0 bg-opacity-50 z-20 flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "m-auto flex flex-col space-y-5 items-center"
}
const _hoisted_3 = { class: "flex-initial m-auto animate-pulse" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "m-auto flex flex-col space-y-5 items-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin -ml-1 mr-3 h-16 w-16 text-primary",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showLogo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.logo,
              class: "h-32"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("span", {
            class: _normalizeClass(["flex-grow text-white font-bold m-auto text-2xl", _ctx.animated ? 'animate-bounce' : ''])
          }, _toDisplayString(_ctx.message), 3)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", {
            class: _normalizeClass(["flex-grow text-white font-bold m-auto text-2xl", _ctx.animated ? 'animate-bounce' : ''])
          }, _toDisplayString(_ctx.message), 3)
        ]))
  ]))
}